module.exports = __webpack_public_path__ + "static/media/publicicon1.8d84800c.svg";